module.exports = __webpack_public_path__ + "img/project_active.ba071f7c.png";